import AjaxLoadedWebsiteModal, {EVENT_MODAL_CONTENT_LOADING_FAILED} from "./AjaxLoadedWebsiteModal";
import Ajax from "base/Ajax";

export default class PostModal extends AjaxLoadedWebsiteModal {

    constructor(postId, type, containerSelector, allowCache = true) {
        super();
        this.postId = postId;
        this.type = type;
        this.containerSelector = containerSelector;
        this.allowCache = allowCache;
    }

    loadPageContent() {
        let request = Ajax.get('wp/v2', this.type + '/' + this.postId, {});

        request.then((data) => {
            this.handleContent(data);
        }).catch((e) => {
            console.warn("Couldn't load modal content", e);
            let error = Ajax.get_ajax_error(e);
            if (this.emit(EVENT_MODAL_CONTENT_LOADING_FAILED, e)) {
                this.displayError(e);
            }
        });
    }

    handleContent(data) {
        console.log(data);

        this.$modal.find('.modal__container').html(
            eotwJSXFactory('div', {className: "modal__box modal__box--case-study"}, [
                eotwJSXFactory('div', {className: "modal__close js-close-modal"}),
                eotwJSXFactory('div', {className: "editable-content"}, [
                    eotwJSXFactory('h2', {className: "heading heading--2"}, [data.title.rendered]),
                    $(eotwJSXFactory('div')).html(data.content.rendered)
                ])
            ])
        );
    }
}
